import React, { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isNullOrUndefined } from '../helpers/object-utils';
import './NavMenu.scss';

export const NavMenu = (props) => {

	const [collapsed, setCollapsed] = useState(false);
	const { user, logout } = useAuth();

	const navigate = useNavigate();
	const authed = !isNullOrUndefined(user);

	const toggleNavbar = () => {
		setCollapsed(!collapsed);
	}

	const handleLogout = (event) => {
		event.stopPropagation();
		event.preventDefault();

		logout();
		navigate('/');
	}

	console.log('useAuth', useAuth);

	return (
		<header>
			<div className="container text-center mt-2">
				<div className="row justify-content-md-center">
					<div className="col col-lg-3 flex-fill">
					</div>
					<div className="col-md-auto flex-fill">
						<div id="logo" className="flex-fill">
							<a href="/">Get Away Today Vacations, Inc.</a>
						</div>
					</div>
					<div className="col col-lg-3 flex-fill">
						{authed &&
							<div className="authed-user d-flex justify-content-end">
								<span>Welcome, {`${user.externalUser?.firstName} ${user.externalUser?.lastName} -`}&nbsp;</span>
								<NavLink className="logout" onClick={handleLogout} href='#'>Sign out</NavLink>
							</div>}
					</div>
				</div>
			</div>
			<Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white" container light>
				{/* <NavbarBrand tag={Link} to="/">Extranet</NavbarBrand> */}
				<NavbarToggler onClick={toggleNavbar} className="mr-2" />
				<Collapse className="d-sm-inline-flex dflex-sm-row-reverse" isOpen={!collapsed} navbar>
					<ul className="navbar-nav flex-grow">
						<NavItem>
							<NavLink tag={Link} className="text-light" to="/">Pricing</NavLink>
						</NavItem>
					</ul>
				</Collapse>
			</Navbar>
			<div className="container menu-bottom-separator mb-3"></div>
		</header>
	)
}